import { FC } from 'react';
import { LayoutContainer } from '@netiva/classifieds-ui';

import { Markdown } from '@/components/ui';
import { ApiBaseUrl, FtpServerUrl } from '@/environment';
import RawContent from './Tutorial.md?raw';

const Content = RawContent.replaceAll('${ApiBaseUrl}', ApiBaseUrl).replaceAll('${FtpServerUrl}', FtpServerUrl || '');

export const Tutorial: FC = () => {
  return (
    <LayoutContainer>
      <Markdown>{Content}</Markdown>
    </LayoutContainer>
  );
};
